// Single source of truth for the shared static-assets CDN host. The poppi
// app derives its brand asset root from this (apps/poppi/config), and lib
// mocks/storybook constants build their URLs from it too.
export const cdnRoot = "https://assets.decovostatic.com";
